/**
  Autogenerated file. Do not edit manually.
  @openapi https://search-bff.envdevel.com/v3/api-docs
*/


export type BusinessArea = typeof BusinessArea[keyof typeof BusinessArea];


export const BusinessArea = {
  residential: 'residential',
  commercial: 'commercial',
} as const;
